import React from 'react'
import Table from './table.component'
import styled from 'styled-components'
import Logomark from './../layout/logomark.component'
import PropTypes from 'prop-types'
import PaginationFunctions from './pagination.functions'
import { setUserPermissions } from '../../../src/helpers'
import { PRIMARY_COLOR, PRIMARY_LIGHT } from '../../styles/colors.style'

const StyledPaginationWrapper = styled.div``
const StyledDivHeader = styled.div`
	border-bottom: 1px solid ${PRIMARY_COLOR};
	color: ${PRIMARY_COLOR};
	display: flex;
	font-size: 3.2rem;
	justify-content: space-between;
	margin-bottom: 1rem;
	padding-bottom: 2rem;
`

const StyledLogoContainer = styled.div`
	text-align: center;
`

const StyledAlert = styled.div`
	color: #fff;
	font-size: 18px;
	background: ${PRIMARY_LIGHT};
	padding: 15px;
	margin-bottom: 15px;
`

/**
 * @param {function} showAlert
 * Receives the rows state and returns a boolean the will show the alert if true
 *
 * @param {string} alertText
 * Text to show in the alert
 *
 * @param {boolean} loadonce
 *
 * */
class PaginationComponent extends React.Component {
	static propTypes = {
		getData: PropTypes.func.isRequired,
		headers: PropTypes.arrayOf(
			PropTypes.shape({
				header: PropTypes.node.isRequired,
				key: PropTypes.string.isRequired,
				align: PropTypes.string,
			})
		).isRequired,
		loadonce: PropTypes.bool,
		params: PropTypes.any,
		renderPaginator: PropTypes.func,
		renderRow: PropTypes.func,
		rowsPerPage: PropTypes.number,
		sortable: PropTypes.shape({
			defaultOrder: PropTypes.string,
			cols: PropTypes.arrayOf(
				PropTypes.shape({
					key: PropTypes.string.isRequired,
					sortFn: PropTypes.func,
				})
			),
		}),
		title: PropTypes.node,
		showAlert: PropTypes.func,
		alertText: PropTypes.string,
		noTitle: PropTypes.bool,
		emptyDatasetText: PropTypes.string,
	}

	constructor(props) {
		super(props)
		const { sortable } = props
		this.state = {
			rows: [],
			displayData: [],
			loading: false,
			page: 1,
			rowsPerPage: props.rowsPerPage || 10,
			totalRows: 0,
			sortable,
			sord: (sortable && sortable.defaultOrder) || 'desc',
			sidx: (sortable && sortable.cols[0].key) || '',
		}
	}

	componentWillReceiveProps({ params: nextParams }) {
		if (nextParams === undefined || this.props.params === undefined) {
			this.setState({ page: 1, totalRows: 0 }, PaginationFunctions.getData)
			return
		}

		const currentValues = Object.values(this.props.params)
		const nextValues = Object.values(nextParams)

		const anyValueChanged = currentValues.some(
			(value, index) => value !== nextValues[index]
		)

		if (anyValueChanged) {
			this.setState({ page: 1, totalRows: 0 }, PaginationFunctions.getData)
		}
	}

	componentDidMount() {
		const { user } = this.props
		setUserPermissions(user)
	}

	componentDidUpdate() {
		const { user } = this.props
		setUserPermissions(user)
	}

	reload() {
		this.setState({ page: 1, totalRows: 0 }, PaginationFunctions.getData)
	}

	render() {
		const {
			title,
			dataTip,
			headers,
			noTitle,
			alertText,
			renderRow,
			showAlert,
			emptyDatasetText,
			footerComponent: FooterComponent,
		} = this.props

		const { rows, sidx, sord, loading, sortable, totalRows, displayData } =
			this.state

		return (
			<StyledPaginationWrapper data-tip={dataTip}>
				{showAlert && !!showAlert(rows) && (
					<StyledAlert>{alertText}</StyledAlert>
				)}
				{noTitle ? null : (
					<StyledDivHeader>
						<span>{title || 'Listagem'}</span>
						<span>
							{totalRows} registro
							{totalRows == 1 ? '' : 's'}
						</span>
					</StyledDivHeader>
				)}
				{loading ? (
					<StyledLogoContainer>
						<Logomark animate />
					</StyledLogoContainer>
				) : (
					<Table
						onClickHeader={(sidx) =>
							totalRows
								? this.setState(
									{
										sidx,
										sord: PaginationFunctions.getSord.call(
											this,
											sidx
										),
									},
									PaginationFunctions.sortRows
								)
								: null
						}
						sidx={sidx}
						sord={sord}
						headers={headers}
						data={displayData}
						sortable={sortable}
						renderRow={renderRow}
						emptyDatasetText={emptyDatasetText}
					/>
				)}
				{PaginationFunctions.renderEmptyDataset.call(this)}
				{FooterComponent && totalRows > 0 && (
					<div
						style={{
							maxWidth: 'calc(100vw - 30px)',
							margin: '0 auto',
						}}>
						<FooterComponent />
					</div>
				)}
				{PaginationFunctions.renderPaginator.call(this)}
			</StyledPaginationWrapper>
		)
	}
}

export default PaginationComponent
